import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const clientFilterSchema = z.object({
	search: optionalFilterString,
	status: z.string().default("ACTIVE"),
});
